export default __webpack_public_path__ + "static/media/pc_man.2835ed97.png";